/* Generated by scripts/generate.ts from src/locales. Do not edit by hand. */
import type { NamespaceBundle } from "../catalogue";
import type { CopyNamespace } from "../generated";
import en_activity from "./en/activity.json";
import en_commitment from "./en/commitment.json";
import en_dealDetails from "./en/deal-details.json";
import en_earningsHub from "./en/earnings-hub.json";
import en_fundOverview from "./en/fund-overview.json";
import en_holding from "./en/holding.json";
import en_home from "./en/home.json";
import en_reallocation from "./en/reallocation.json";
import en_transitions from "./en/transitions.json";

export const SUPPORTED_LOCALES = ["en"] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const BUNDLES: Readonly<Record<CopyNamespace, NamespaceBundle>> = {
  "activity": {
    "en": {
      base: en_activity,
      overlays: {},
    },
  },
  "commitment": {
    "en": {
      base: en_commitment,
      overlays: {},
    },
  },
  "deal-details": {
    "en": {
      base: en_dealDetails,
      overlays: {},
    },
  },
  "earnings-hub": {
    "en": {
      base: en_earningsHub,
      overlays: {},
    },
  },
  "fund-overview": {
    "en": {
      base: en_fundOverview,
      overlays: {},
    },
  },
  "holding": {
    "en": {
      base: en_holding,
      overlays: {},
    },
  },
  "home": {
    "en": {
      base: en_home,
      overlays: {},
    },
  },
  "reallocation": {
    "en": {
      base: en_reallocation,
      overlays: {},
    },
  },
  "transitions": {
    "en": {
      base: en_transitions,
      overlays: {},
    },
  },
};
